import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "my-5" }
const _hoisted_2 = { class: "d-flex justify-content-center mb-9" }
const _hoisted_3 = { class: "mb-9" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "text-danger text-center"
}
const _hoisted_6 = { class: "d-flex justify-content-center" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border h-15px w-15px align-middle text-gray-400" }, null, -1)
const _hoisted_9 = { key: 1 }

import { ref, inject } from "vue";
import SimpleForm from "@/components/SimpleForm.vue";
import UserService from "../../services/UserService";
import { PartyStatusTypes } from "@/core/types/PartyStatusTypes";
import { ElNotification } from "element-plus";
import i18n from "@/core/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateUserStatus',
  setup(__props, { expose: __expose }) {

const t = i18n.global.t;
const isLoading = ref(false);
const modalForm = ref<InstanceType<typeof SimpleForm>>();
const userInfos = inject<any>("userInfos");
const comment = ref("");
const status = ref(userInfos.value.status);
const showCommentError = ref(false);

const updateStatus = async () => {
  if (!comment.value || comment.value.trim() === "") {
    showCommentError.value = true;
    return;
  }
  showCommentError.value = false;
  isLoading.value = true;

  try {
    let form = {
      status: status.value,
      comment: comment.value,
    };
    await UserService.updateUserStatus(userInfos.value.partyId, form);
    ElNotification({
      title: t("status.success"),
      message: t("tip.updateSuccess"),
      type: "success",
    });
    userInfos.value.status = status.value;
    modalForm.value?.hide();
  } catch (error) {
    ElNotification({
      title: t("status.failed"),
      message: t("tip.updateFailed"),
      type: "error",
    });
  } finally {
    isLoading.value = false;
  }
};

__expose({
  async show() {
    modalForm.value?.show();
  },
  hide() {
    modalForm.value?.hide();
  },
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(SimpleForm, {
      ref_key: "modalForm",
      ref: modalForm,
      title: _ctx.$t('fields.updateUserStatus'),
      "is-loading": isLoading.value,
      "disable-footer": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_select, {
              modelValue: status.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((status).value = $event)),
              disabled: isLoading.value,
              placeholder: "Select",
              class: "w-250px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: _ctx.$t('status.active'),
                  value: _unref(PartyStatusTypes).Active
                }, null, 8, ["label", "value"]),
                _createVNode(_component_el_option, {
                  label: _ctx.$t('status.inactive'),
                  value: _unref(PartyStatusTypes).Closed
                }, null, 8, ["label", "value"])
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "d-flex justify-content-center",
              disabled: isLoading.value
            }, [
              _createVNode(_component_el_input, {
                modelValue: comment.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((comment).value = $event)),
                class: "mb-2 w-250px",
                placeholder: _ctx.$t('tip.enterReason'),
                type: "textarea"
              }, null, 8, ["modelValue", "placeholder"])
            ], 8, _hoisted_4),
            (showCommentError.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t("error.fieldIsRequired")), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "btn btn-light btn-success btn-md me-3",
              onClick: updateStatus
            }, [
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.waiting")) + " ", 1),
                    _hoisted_8
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t("action.update")), 1))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["title", "is-loading"])
  ]))
}
}

})